import React, {Component} from 'react';
import '../assets/css/connection_status.css'

class ConnectionStatus extends Component {
    constructor(props) {
        super(props);
        this.state = {
            online: true,
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // let isOnline = window.navigator.onLine;
        // // setInterval()
        // if (prevState.online !== isOnline) {
        //     this.setState({online: !this.state.online})
        // }
    }

    componentDidMount() {
        setInterval(() => {
            let isOnline = window.navigator.onLine;
            if (isOnline) {
                this.setState({online: true})
            } else {
                this.setState({online: false})
            }

        }, 5000);
    }

    // componentWillMount() {
    //     setInterval(function () {
    //         let isOnline = window.navigator.onLine;
    //         if (isOnline) {
    //             this.setState({online: true})
    //         } else {
    //             this.setState({online: false})
    //         }
    //
    //     }, 5000);
    // }

    render() {
        if (this.state.online) {
            return null;
        }
        return (
            <div id="connection_status">Нет подключения к интернету</div>
        )
    }
}

export default ConnectionStatus;



// WEBPACK FOOTER //
// ./src/components/ConnectionStatus.js